import routerOptions0 from "/home/runner/work/suwo/suwo/website/app/router.options.ts";
import routerOptions1 from "/home/runner/work/suwo/suwo/website/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}